import React from "react"

import { useFormikContext } from "formik"

import Button, { ButtonProps } from "~tailwindui/Basics/Button"

export type SubmitButtonProps = Omit<
  ButtonProps,
  "loading" | "disabled" | "type"
> & {
  submitting?: boolean
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  text = "Save",
  submitting = undefined,
  ...props
}) => {
  const formikContext = useFormikContext()
  let submissionStatus = formikContext?.isSubmitting
  if (submitting !== undefined) submissionStatus = submitting

  return (
    <Button
      type="submit"
      text={text}
      loading={submissionStatus}
      disabled={submissionStatus}
      {...props}
    />
  )
}

export default SubmitButton
